import * as c from "react";
import { useState as he } from "react";
import { u as me, P as ge } from "./index-Bud8rdvZ.js";
import { u as G } from "./index-0ioNhtNM.js";
import { jsx as pe } from "react/jsx-runtime";
import { _ as k, a as oe, b as ye } from "./tslib.es6-fInlAbov.js";
var U = "focusScope.autoFocusOnMount", _ = "focusScope.autoFocusOnUnmount", Z = { bubbles: !1, cancelable: !0 }, be = "FocusScope", Ee = c.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: u,
    onUnmountAutoFocus: i,
    ...s
  } = e, [a, S] = c.useState(null), y = G(u), g = G(i), f = c.useRef(null), v = me(t, (o) => S(o)), h = c.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  c.useEffect(() => {
    if (r) {
      let o = function(m) {
        if (h.paused || !a) return;
        const p = m.target;
        a.contains(p) ? f.current = p : C(f.current, { select: !0 });
      }, l = function(m) {
        if (h.paused || !a) return;
        const p = m.relatedTarget;
        p !== null && (a.contains(p) || C(f.current, { select: !0 }));
      }, d = function(m) {
        if (document.activeElement === document.body)
          for (const b of m)
            b.removedNodes.length > 0 && C(a);
      };
      document.addEventListener("focusin", o), document.addEventListener("focusout", l);
      const E = new MutationObserver(d);
      return a && E.observe(a, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", o), document.removeEventListener("focusout", l), E.disconnect();
      };
    }
  }, [r, a, h.paused]), c.useEffect(() => {
    if (a) {
      Q.add(h);
      const o = document.activeElement;
      if (!a.contains(o)) {
        const d = new CustomEvent(U, Z);
        a.addEventListener(U, y), a.dispatchEvent(d), d.defaultPrevented || (Se(Ae(ce(a)), { select: !0 }), document.activeElement === o && C(a));
      }
      return () => {
        a.removeEventListener(U, y), setTimeout(() => {
          const d = new CustomEvent(_, Z);
          a.addEventListener(_, g), a.dispatchEvent(d), d.defaultPrevented || C(o ?? document.body, { select: !0 }), a.removeEventListener(_, g), Q.remove(h);
        }, 0);
      };
    }
  }, [a, y, g, h]);
  const w = c.useCallback(
    (o) => {
      if (!n && !r || h.paused) return;
      const l = o.key === "Tab" && !o.altKey && !o.ctrlKey && !o.metaKey, d = document.activeElement;
      if (l && d) {
        const E = o.currentTarget, [m, p] = we(E);
        m && p ? !o.shiftKey && d === p ? (o.preventDefault(), n && C(m, { select: !0 })) : o.shiftKey && d === m && (o.preventDefault(), n && C(p, { select: !0 })) : d === E && o.preventDefault();
      }
    },
    [n, r, h.paused]
  );
  return /* @__PURE__ */ pe(ge.div, { tabIndex: -1, ...s, ref: v, onKeyDown: w });
});
Ee.displayName = be;
function Se(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (C(r, { select: t }), document.activeElement !== n) return;
}
function we(e) {
  const t = ce(e), n = q(t, e), r = q(t.reverse(), e);
  return [n, r];
}
function ce(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const u = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || u ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function q(e, t) {
  for (const n of e)
    if (!Ce(n, { upTo: t })) return n;
}
function Ce(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function ke(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function C(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && ke(e) && t && e.select();
  }
}
var Q = Re();
function Re() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && n?.pause(), e = $(e, t), e.unshift(t);
    },
    remove(t) {
      e = $(e, t), e[0]?.resume();
    }
  };
}
function $(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function Ae(e) {
  return e.filter((t) => t.tagName !== "A");
}
var K = 0;
function pt() {
  c.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? J()), document.body.insertAdjacentElement("beforeend", e[1] ?? J()), K++, () => {
      K === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), K--;
    };
  }, []);
}
function J() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var W = "right-scroll-bar-position", B = "width-before-scroll-bar", Te = "with-scroll-bars-hidden", Fe = "--removed-body-scroll-bar-size";
function H(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Me(e, t) {
  var n = he(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var u = n.value;
          u !== r && (n.value = r, n.callback(r, u));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var Ne = typeof window < "u" ? c.useLayoutEffect : c.useEffect, ee = /* @__PURE__ */ new WeakMap();
function Pe(e, t) {
  var n = Me(null, function(r) {
    return e.forEach(function(u) {
      return H(u, r);
    });
  });
  return Ne(function() {
    var r = ee.get(n);
    if (r) {
      var u = new Set(r), i = new Set(e), s = n.current;
      u.forEach(function(a) {
        i.has(a) || H(a, null);
      }), i.forEach(function(a) {
        u.has(a) || H(a, s);
      });
    }
    ee.set(n, e);
  }, [e]), n;
}
function Le(e) {
  return e;
}
function Ie(e, t) {
  t === void 0 && (t = Le);
  var n = [], r = !1, u = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var s = t(i, r);
      return n.push(s), function() {
        n = n.filter(function(a) {
          return a !== s;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(i);
      }
      n = {
        push: function(a) {
          return i(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var s = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(i), s = n;
      }
      var S = function() {
        var g = s;
        s = [], g.forEach(i);
      }, y = function() {
        return Promise.resolve().then(S);
      };
      y(), n = {
        push: function(g) {
          s.push(g), y();
        },
        filter: function(g) {
          return s = s.filter(g), n;
        }
      };
    }
  };
  return u;
}
function xe(e) {
  e === void 0 && (e = {});
  var t = Ie(null);
  return t.options = k({ async: !0, ssr: !1 }, e), t;
}
var ue = function(e) {
  var t = e.sideCar, n = oe(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return c.createElement(r, k({}, n));
};
ue.isSideCarExport = !0;
function Oe(e, t) {
  return e.useMedium(t), ue;
}
var ie = xe(), V = function() {
}, D = c.forwardRef(function(e, t) {
  var n = c.useRef(null), r = c.useState({
    onScrollCapture: V,
    onWheelCapture: V,
    onTouchMoveCapture: V
  }), u = r[0], i = r[1], s = e.forwardProps, a = e.children, S = e.className, y = e.removeScrollBar, g = e.enabled, f = e.shards, v = e.sideCar, h = e.noIsolation, w = e.inert, o = e.allowPinchZoom, l = e.as, d = l === void 0 ? "div" : l, E = e.gapMode, m = oe(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), p = v, b = Pe([n, t]), R = k(k({}, m), u);
  return c.createElement(
    c.Fragment,
    null,
    g && c.createElement(p, { sideCar: ie, removeScrollBar: y, shards: f, noIsolation: h, inert: w, setCallbacks: i, allowPinchZoom: !!o, lockRef: n, gapMode: E }),
    s ? c.cloneElement(c.Children.only(a), k(k({}, R), { ref: b })) : c.createElement(d, k({}, R, { className: S, ref: b }), a)
  );
});
D.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
D.classNames = {
  fullWidth: B,
  zeroRight: W
};
var We = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Be() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = We();
  return t && e.setAttribute("nonce", t), e;
}
function De(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Ue(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var _e = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = Be()) && (De(t, n), Ue(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Ke = function() {
  var e = _e();
  return function(t, n) {
    c.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, le = function() {
  var e = Ke(), t = function(n) {
    var r = n.styles, u = n.dynamic;
    return e(r, u), null;
  };
  return t;
}, He = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, X = function(e) {
  return parseInt(e || "", 10) || 0;
}, Ve = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], u = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [X(n), X(r), X(u)];
}, Xe = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return He;
  var t = Ve(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, Ye = le(), M = "data-scroll-locked", je = function(e, t, n, r) {
  var u = e.left, i = e.top, s = e.right, a = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(Te, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(a, "px ").concat(r, `;
  }
  body[`).concat(M, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(u, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(a, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(W, ` {
    right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(B, ` {
    margin-right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(W, " .").concat(W, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(B, " .").concat(B, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(M, `] {
    `).concat(Fe, ": ").concat(a, `px;
  }
`);
}, te = function() {
  var e = parseInt(document.body.getAttribute(M) || "0", 10);
  return isFinite(e) ? e : 0;
}, ze = function() {
  c.useEffect(function() {
    return document.body.setAttribute(M, (te() + 1).toString()), function() {
      var e = te() - 1;
      e <= 0 ? document.body.removeAttribute(M) : document.body.setAttribute(M, e.toString());
    };
  }, []);
}, Ge = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, u = r === void 0 ? "margin" : r;
  ze();
  var i = c.useMemo(function() {
    return Xe(u);
  }, [u]);
  return c.createElement(Ye, { styles: je(i, !t, u, n ? "" : "!important") });
}, j = !1;
if (typeof window < "u")
  try {
    var L = Object.defineProperty({}, "passive", {
      get: function() {
        return j = !0, !0;
      }
    });
    window.addEventListener("test", L, L), window.removeEventListener("test", L, L);
  } catch {
    j = !1;
  }
var A = j ? { passive: !1 } : !1, Ze = function(e) {
  return e.tagName === "TEXTAREA";
}, se = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Ze(e) && n[t] === "visible")
  );
}, qe = function(e) {
  return se(e, "overflowY");
}, Qe = function(e) {
  return se(e, "overflowX");
}, ne = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var u = fe(e, r);
    if (u) {
      var i = de(e, r), s = i[1], a = i[2];
      if (s > a)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, $e = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, Je = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, fe = function(e, t) {
  return e === "v" ? qe(t) : Qe(t);
}, de = function(e, t) {
  return e === "v" ? $e(t) : Je(t);
}, et = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, tt = function(e, t, n, r, u) {
  var i = et(e, window.getComputedStyle(t).direction), s = i * r, a = n.target, S = t.contains(a), y = !1, g = s > 0, f = 0, v = 0;
  do {
    var h = de(e, a), w = h[0], o = h[1], l = h[2], d = o - l - i * w;
    (w || d) && fe(e, a) && (f += d, v += w), a instanceof ShadowRoot ? a = a.host : a = a.parentNode;
  } while (
    // portaled content
    !S && a !== document.body || // self content
    S && (t.contains(a) || t === a)
  );
  return (g && Math.abs(f) < 1 || !g && Math.abs(v) < 1) && (y = !0), y;
}, I = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, re = function(e) {
  return [e.deltaX, e.deltaY];
}, ae = function(e) {
  return e && "current" in e ? e.current : e;
}, nt = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, rt = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, at = 0, T = [];
function ot(e) {
  var t = c.useRef([]), n = c.useRef([0, 0]), r = c.useRef(), u = c.useState(at++)[0], i = c.useState(le)[0], s = c.useRef(e);
  c.useEffect(function() {
    s.current = e;
  }, [e]), c.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(u));
      var o = ye([e.lockRef.current], (e.shards || []).map(ae), !0).filter(Boolean);
      return o.forEach(function(l) {
        return l.classList.add("allow-interactivity-".concat(u));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(u)), o.forEach(function(l) {
          return l.classList.remove("allow-interactivity-".concat(u));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = c.useCallback(function(o, l) {
    if ("touches" in o && o.touches.length === 2 || o.type === "wheel" && o.ctrlKey)
      return !s.current.allowPinchZoom;
    var d = I(o), E = n.current, m = "deltaX" in o ? o.deltaX : E[0] - d[0], p = "deltaY" in o ? o.deltaY : E[1] - d[1], b, R = o.target, N = Math.abs(m) > Math.abs(p) ? "h" : "v";
    if ("touches" in o && N === "h" && R.type === "range")
      return !1;
    var P = ne(N, R);
    if (!P)
      return !0;
    if (P ? b = N : (b = N === "v" ? "h" : "v", P = ne(N, R)), !P)
      return !1;
    if (!r.current && "changedTouches" in o && (m || p) && (r.current = b), !b)
      return !0;
    var z = r.current || b;
    return tt(z, l, o, z === "h" ? m : p);
  }, []), S = c.useCallback(function(o) {
    var l = o;
    if (!(!T.length || T[T.length - 1] !== i)) {
      var d = "deltaY" in l ? re(l) : I(l), E = t.current.filter(function(b) {
        return b.name === l.type && (b.target === l.target || l.target === b.shadowParent) && nt(b.delta, d);
      })[0];
      if (E && E.should) {
        l.cancelable && l.preventDefault();
        return;
      }
      if (!E) {
        var m = (s.current.shards || []).map(ae).filter(Boolean).filter(function(b) {
          return b.contains(l.target);
        }), p = m.length > 0 ? a(l, m[0]) : !s.current.noIsolation;
        p && l.cancelable && l.preventDefault();
      }
    }
  }, []), y = c.useCallback(function(o, l, d, E) {
    var m = { name: o, delta: l, target: d, should: E, shadowParent: ct(d) };
    t.current.push(m), setTimeout(function() {
      t.current = t.current.filter(function(p) {
        return p !== m;
      });
    }, 1);
  }, []), g = c.useCallback(function(o) {
    n.current = I(o), r.current = void 0;
  }, []), f = c.useCallback(function(o) {
    y(o.type, re(o), o.target, a(o, e.lockRef.current));
  }, []), v = c.useCallback(function(o) {
    y(o.type, I(o), o.target, a(o, e.lockRef.current));
  }, []);
  c.useEffect(function() {
    return T.push(i), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: v
    }), document.addEventListener("wheel", S, A), document.addEventListener("touchmove", S, A), document.addEventListener("touchstart", g, A), function() {
      T = T.filter(function(o) {
        return o !== i;
      }), document.removeEventListener("wheel", S, A), document.removeEventListener("touchmove", S, A), document.removeEventListener("touchstart", g, A);
    };
  }, []);
  var h = e.removeScrollBar, w = e.inert;
  return c.createElement(
    c.Fragment,
    null,
    w ? c.createElement(i, { styles: rt(u) }) : null,
    h ? c.createElement(Ge, { gapMode: e.gapMode }) : null
  );
}
function ct(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const ut = Oe(ie, ot);
var it = c.forwardRef(function(e, t) {
  return c.createElement(D, k({}, e, { ref: t, sideCar: ut }));
});
it.classNames = D.classNames;
var lt = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, F = /* @__PURE__ */ new WeakMap(), x = /* @__PURE__ */ new WeakMap(), O = {}, Y = 0, ve = function(e) {
  return e && (e.host || ve(e.parentNode));
}, st = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = ve(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, ft = function(e, t, n, r) {
  var u = st(t, Array.isArray(e) ? e : [e]);
  O[n] || (O[n] = /* @__PURE__ */ new WeakMap());
  var i = O[n], s = [], a = /* @__PURE__ */ new Set(), S = new Set(u), y = function(f) {
    !f || a.has(f) || (a.add(f), y(f.parentNode));
  };
  u.forEach(y);
  var g = function(f) {
    !f || S.has(f) || Array.prototype.forEach.call(f.children, function(v) {
      if (a.has(v))
        g(v);
      else
        try {
          var h = v.getAttribute(r), w = h !== null && h !== "false", o = (F.get(v) || 0) + 1, l = (i.get(v) || 0) + 1;
          F.set(v, o), i.set(v, l), s.push(v), o === 1 && w && x.set(v, !0), l === 1 && v.setAttribute(n, "true"), w || v.setAttribute(r, "true");
        } catch (d) {
          console.error("aria-hidden: cannot operate on ", v, d);
        }
    });
  };
  return g(t), a.clear(), Y++, function() {
    s.forEach(function(f) {
      var v = F.get(f) - 1, h = i.get(f) - 1;
      F.set(f, v), i.set(f, h), v || (x.has(f) || f.removeAttribute(r), x.delete(f)), h || f.removeAttribute(n);
    }), Y--, Y || (F = /* @__PURE__ */ new WeakMap(), F = /* @__PURE__ */ new WeakMap(), x = /* @__PURE__ */ new WeakMap(), O = {});
  };
}, yt = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), u = lt(e);
  return u ? (r.push.apply(r, Array.from(u.querySelectorAll("[aria-live]"))), ft(r, u, n, "aria-hidden")) : function() {
    return null;
  };
};
export {
  Ee as F,
  it as R,
  yt as h,
  pt as u
};
